import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type { GuideCarouselCardData } from '@module/types/card/type';
interface GuideStepListProps {
  stepList: GuideCarouselCardData[];
  additionalElements?: {
    stepIndex: number;
    element: React.ReactNode;
  }[];
}
function GuideStepList(t0) {
  const $ = _c(7);
  const {
    stepList,
    additionalElements
  } = t0;
  let t1;
  if ($[0] !== additionalElements || $[1] !== stepList) {
    let t2;
    if ($[3] !== additionalElements) {
      t2 = (t3, stepIndex) => {
        const {
          contents,
          imgSrc,
          imgClass,
          imgContainerClass
        } = t3;
        const {
          title,
          subTitle,
          explanationSentenceList
        } = contents[0];
        return <div key={title} className="flex items-start justify-between pt-[56px]"><div className="flex w-[506px] shrink-0 flex-col"><div className="flex flex-col"><h4 className="mb-4 text-colorFg18 text-xl">{title}</h4>{subTitle && <p className="mb-4 whitespace-pre-wrap text-baseFg">{subTitle}</p>}<ol className="flex flex-col gap-3">{explanationSentenceList.map(_temp)}</ol>{additionalElements?.find(item => item.stepIndex === stepIndex)?.element}</div></div><div className={cn("min-w-0 flex-1 overflow-hidden", imgContainerClass)}><img src={imgSrc} alt={title} className={cn("inline-block w-full", imgClass)} /></div></div>;
      };
      $[3] = additionalElements;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = stepList.map(t2);
    $[0] = additionalElements;
    $[1] = stepList;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="flex flex-col gap-10 rounded-[20px] bg-colorBg01 px-[96px] py-10">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(sentence, i) {
  return <li key={sentence} className="flex items-start gap-[10px]"><div className="flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full bg-red-500 text-[13px] text-white leading-[19px]">{i + 1}</div><span className="whitespace-pre-wrap text-[16px] text-baseFg leading-[22px] tracking-[-0.5px]">{sentence}</span></li>;
}
export default GuideStepList;